"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVFromSFUOverAllowedReason = void 0;
var AVFromSFUOverAllowedReason;
(function (AVFromSFUOverAllowedReason) {
    AVFromSFUOverAllowedReason["PlayerLimit"] = "Sharing A/V with too many people";
    AVFromSFUOverAllowedReason["ResourceLimit"] = "Video server resources are temporarily unavailable";
})(AVFromSFUOverAllowedReason || (exports.AVFromSFUOverAllowedReason = AVFromSFUOverAllowedReason = {}));
//# sourceMappingURL=fromSFU.js.map